import React from "react";
import { useLocation } from "react-router-dom";

// Sempre que a rota (pathname) mudar, volta o scroll para o topo da página.
// Sem isso, o React Router mantém a posição de scroll da página anterior
// ao trocar de rota via <Link>/<NavLink>.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
